import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption
} from '@angular/material/autocomplete';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Observable } from 'rxjs';
import {
  ErroMessages,
  IEntity,
  IErroMessages,
  IRoute,
  TokenService
} from 'viggo-sistemas-core-web';
import { UserDisponivelService } from './users-disponivel.service';

// const components = {
//   condicao_pgmt: {
//     component: FastCondPgmtComponent,
//     config: {
//       width: '800px',
//       data: {
//         entity: {
//           parcelas: []
//         } as ICondicaoPagamento
//       }
//     }
//   }
// }

@Component({
  selector: 'autocomplete-users',
  templateUrl: './autocomplete-users.component.html',
  providers: [UserDisponivelService]
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class AutoCompleteUsers<T extends IEntity = any>
  implements OnInit, OnDestroy {
  @Input() user_id: string;
  @Input() routesAuthorization: IRoute[] = [];
  @Input() data: any = {};
  /**
   * Placeholder usado pelo input
   */
  @Input() placeholder = 'Digite aqui';
  /**
   * Exibe mensagem de erro, caso haja
   */
  @Input() errorMsg = '';
  /**
   * Mensagens de erro
   */
  @Input() messages: { [key: string]: string };

  @Input() displayField = 'id';

  @Input() displaySecondField = 'id';
  /**
   * Tipo de input do autocomplete
   */
  @Input() inputType = 'text';
  /**
   * Identifica se o campo é de preenchimento obrigatório
   */
  @Input() public readonly required = false;
  /**
   * Função para exibir os dados do autocomplete
   * @deprecated
   */
  @Input() displayWith: (obj: T) => string = obj => obj.toString();
  /**
   * O FormControl responsável por gerenciar o input
   * @required
   */
  @Input() control: UntypedFormControl;
  /**
   * Configuração de selecionar automaticamente o uncio resultado
   */
  @Input() public autoFirst: boolean = false;

  /**
   * Configuração de exibir automaticamente os primeiros resultados
   */
  @Input() public notShowResultsFirst: boolean = true;
  /**
   * Inicia dados preenchido quando a busca for vazia
   */

  @Input() public readonly initDataWithEmpty: boolean = true;

  /**
   * Caso o usuario queira repassar sua própria função de busca
   * É possível atravês dessa props
   */
  @Input() public readonly searchFN: (
    value: string
  ) => Observable<any[]> = null;
  /**
   * Função chamada sempre que há uma requisição a API
   * Implementa lógica caso seja nescessário filtar as entidades
   * vindas do banco de dados, ex: impedir auto relacionamento de entidades
   * @param entities entidades vindas da requisição
   * @tutorial rulesFilterEntities Cuidado com a perda de contexto do "this" use arrow functions
   * ou tenha certeza que o contexto chamado seja da sua classe externa com o bind.
   */
  @Input() rulesFilterEntities: (entities: any) => any = entities => entities;

  /**
   * Quando os resultados são carregados da api, este evento é acionado, repassando
   * os resultados retornados da api
   */
  @Output() public onLoadResults = new EventEmitter<any>();

  filteredEntities: any = [];
  /**
   * Id do dominio onde a infomação deve ser pesquisada
   */
  @Input() cliente_id: string;

  @Input() domain_id: string;

  @Input() value_order: string;

  @Input() pageValue: number = 0;

  @Input() pageSizeValue: number = 10;

  pageLength = 0;

  @Input() controlIsEnabled = true;

  @Input() public readonly include: string[] = null;

  /**
   * Mostra a entidade selecionada
   * @param entity entidade a ser mostrada
   */
  @Input() displayWithEntityFn = (entity: T | string) => {
    if (!entity) return '';
    if (typeof entity === 'string') return entity;
    return entity[this.displayField];
  };

  /**
   * É possivel repassar paremetros adicionais para a requisição
   */
  @Input() params: { [param: string]: string } = {};

  @Input() readonly = false;

  @Input() actionState = true;

  /**
   * Emite eventos sempre que o autocomplete
   * precisar forçar a seleção de uma entidade
   * @description Emite o evento quando a entidade é selecionada
   */

  @Output() selectEntity: EventEmitter<T> = new EventEmitter();
  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter();
  @Output() public clearSelection = new EventEmitter<boolean>();

  @Input() hiddenRemoveValue = false;
  @Input() forcedNotShowOptions = false;
  public notShowOptions = false;
  public isLoading = false;
  public noResults = false;
  public stateSearch = false;
  valueControlStrChange = false;
  isClear = false;

  constructor(
    protected userService: UserDisponivelService,
    protected tokenService: TokenService,
    public matDialog: MatDialog,
    public matSnackBar: MatSnackBar,
    public router: Router
  ) {}

  @ViewChild('usersAutocomplete') itensAutocomplete: MatAutocomplete;
  @ViewChild('triggerUsers') trigger: MatAutocompleteTrigger;
  lastScrollTop = 0;
  keyEntities = 0;

  scroll = (event): void => {
    const element = this.itensAutocomplete.panel?.nativeElement;
    if (element) {
      if (element.scrollTop < this.lastScrollTop) {
        // upscroll
        return;
      }
      this.lastScrollTop = element.scrollTop <= 0 ? 0 : element.scrollTop;
      if (element.scrollTop + element.offsetHeight >= element.scrollHeight) {
        if (
          this.filteredEntities.length > 0 &&
          this.filteredEntities.length !== this.pageLength
        ) {
          this.pageValue++;
          var strFilter = null;
          if (
            this.control.value &&
            this.control.value !== '' &&
            typeof this.control.value === 'string'
          )
            strFilter = this.control.value.trim();
          this.onLoad(strFilter);
        }
      }
    }
  };

  onKeyEnter(event) {
    const elementTrigger = this.trigger;
    const elementPanelAt = this.itensAutocomplete;
    if (
      elementTrigger &&
      !elementTrigger.activeOption &&
      !this.control.value &&
      typeof (event.target as any).value === 'string' &&
      event.key === 'Enter' &&
      event.keyCode === 13
    ) {
      if (this.isLastValueActivated) {
        this.control.setValue(this.isLastValueActivated);
        elementPanelAt.options
          .toArray()
          .find(it => it.value && it.value.id === this.isLastValueActivated.id)
          .select();
      } else {
        this.stateSearch = true;
        this.valueControlStrChange = false;
        this.pageValue = 0;
        this.lastScrollTop = 0;
        this.keyEntities = 0;
        this.filteredEntities = [];
        this.onLoad((event.target as any).value.trim());
      }
    }
  }

  onKeyDown(event) {
    const elementPanelAt = this.itensAutocomplete.panel?.nativeElement;
    const elementTrigger = this.trigger;
    if (
      elementPanelAt &&
      elementTrigger &&
      elementTrigger.activeOption &&
      elementTrigger.activeOption.value &&
      elementTrigger.activeOption.id !== 'addBtn' &&
      event.key === 'ArrowDown' &&
      event.keyCode === 40
    ) {
      this.keyEntities =
        this.filteredEntities.findIndex(
          it => it.id === this.trigger.activeOption.value.id
        ) + 1;
      if (this.keyEntities >= this.filteredEntities.length) {
        if (
          this.filteredEntities.length > 0 &&
          this.filteredEntities.length !== this.pageLength
        ) {
          this.pageValue++;
          var strFilter = null;
          if (
            this.control.value &&
            this.control.value !== '' &&
            typeof this.control.value === 'string'
          )
            strFilter = this.control.value.trim();
          this.onLoad(strFilter, event);
        }
      }
    }
    // else if (
    //   elementPanelAt &&
    //   elementTrigger &&
    //   elementTrigger.activeOption &&
    //   elementTrigger.activeOption.id === 'addBtn' &&
    //   event.key === 'Enter' &&
    //   event.keyCode === 13
    // ) {
    //   this.isBtnActive = false;
    //   if (this.openDialogAddEntity) this.openDialogAddEntity();
    //   else this.openDialogFast();
    // }
  }

  isLastActivated: MatOption;
  isLastValueActivated: any;
  isBtnActive: boolean = false;
  onOptionActivated(e: { source: MatAutocomplete; option: MatOption }) {
    if (e && e.option && e.option.value) {
      this.isBtnActive = false;
      this.isLastActivated = e.option;
      this.isLastValueActivated = e.option.value;
    } else if (e && e.option && e.option.id === 'addBtn')
      this.isBtnActive = true;
    else this.isBtnActive = false;
  }

  forcedSelectedAndActivatedOption(event) {
    if (this.isLastActivated && this.itensAutocomplete && this.trigger) {
      var firstEnabledOptionIndex = -1;
      const element = this.isLastActivated._getHostElement();
      const newScrollPosition = this._getOptionScrollPosition(
        element.offsetTop,
        element.offsetHeight,
        this.itensAutocomplete._getScrollTop(),
        this.itensAutocomplete.panel?.nativeElement.offsetHeight
      );
      this.itensAutocomplete._setScrollTop(newScrollPosition);

      for (
        let index = 0;
        index < this.itensAutocomplete.options.length;
        index++
      ) {
        const option = this.itensAutocomplete.options.get(index)!;
        if (
          !option.disabled &&
          option.value &&
          option.value.id === this.isLastActivated.value.id
        ) {
          firstEnabledOptionIndex = index;
          break;
        }
      }
      this.itensAutocomplete._keyManager.setActiveItem(firstEnabledOptionIndex);
      this.itensAutocomplete._keyManager.activeItem.focus();
      // this.trigger.writeValue(
      //   this.itensAutocomplete._keyManager.activeItem.value
      // );
      // event.target.value = this.itensAutocomplete._keyManager.activeItem.value[
      //   this.displayField
      // ];
    }
  }

  _getOptionScrollPosition(
    optionOffset: number,
    optionHeight: number,
    currentScrollPosition: number,
    panelHeight: number
  ): number {
    if (optionOffset < currentScrollPosition) {
      return optionOffset;
    }

    if (optionOffset + optionHeight > currentScrollPosition + panelHeight) {
      return Math.max(0, optionOffset - panelHeight + optionHeight);
    }

    return currentScrollPosition;
  }

  onSearch() {
    if (
      this.control.value &&
      this.control.value !== '' &&
      typeof this.control.value === 'string'
    ) {
      this.stateSearch = true;
      this.valueControlStrChange = false;
      this.pageValue = 0;
      this.lastScrollTop = 0;
      this.keyEntities = 0;
      this.filteredEntities = [];
      this.onLoad(this.control.value.trim());
    }
  }

  onLoad(textFilter: string, event?) {
    this.isLoading = true;
    var where = {} as any;
    if (textFilter) {
      where = {
        ...where,
        field: 'name',
        value: `${textFilter}%`
      };
    }
    this.userService
      .usuariosDisponiveis(
        this.domain_id,
        this.user_id,
        this.include,
        {
          require_pagination: true,
          page_size: this.pageSizeValue,
          page: this.pageValue
        },
        this.value_order,
        where
      )
      .subscribe(
        entities => {
          this.isLoading = false;
          if (!this.forcedNotShowOptions) this.notShowOptions = false;
          this.pageLength = entities.pagination.total;
          this.filteredEntities = this.filteredEntities.concat(entities.user);
          this.noResults = this.filteredEntities.length === 0;
          if (event) this.forcedSelectedAndActivatedOption(event);
          if (
            this.filteredEntities &&
            this.filteredEntities.length === 1 &&
            this.autoFirst
          ) {
            this.control.setValue(this.filteredEntities[0]);
            this.selectEntity.emit(this.filteredEntities[0]);
          }
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
  }

  ngOnInit() {
    window.addEventListener('scroll', this.scroll, true);
    this.stateSearch = true;
    this.notShowOptions = true;
    this.onLoad(null);
    this.control.valueChanges.subscribe(text => {
      if (this.stateSearch) {
        if (typeof text === 'string') {
          if (text === '') this.clearSelectValue();
          else {
            this.valueControlStrChange = true;
            // this.notShowOptions = true;
          }
        }
        // else if (typeof text === 'object' && !text) {
        //   this.clearSelectValue();
        // }
      } else if (typeof text === 'string') {
        if (text === '') this.clearSelectValue();
        else {
          this.valueControlStrChange = true;
          // this.notShowOptions = true;
        }
      } else {
        this.valueControlStrChange = false;
      }
    });
  }

  confirmSelection(entity) {
    // this.notShowOptions = true;
    this.control.setValue(entity);
    this.selectEntity.emit(entity);
  }

  getParamsByInclude(includes: string[]): string {
    if (includes.length > 0) return `include=${includes.join(',')}`;
    return '';
  }
  getKey(): string {
    return Object.keys(this.control.errors)[0];
  }

  enterSearch(event: KeyboardEvent) {
    if (event.key === 'Enter' && event.keyCode === 13) {
      if (
        this.control.value &&
        this.control.value !== '' &&
        typeof this.control.value === 'string'
      ) {
        this.onSearch();
      } else {
        this.onKeyEnter(event);
      }
    }
  }

  getBtnIcon() {
    if (
      !this.hiddenRemoveValue &&
      ((typeof this.control.value === 'object' && this.control.value) ||
        (typeof this.control.value === 'string' &&
          this.control.value !== '' &&
          this.noResults))
    ) {
      return 'pi pi-times-circle';
    } else if (
      this.filteredEntities.length !== 0 &&
      !this.valueControlStrChange
    ) {
      return 'pi pi-angle-down';
    } else if (
      typeof this.control.value === 'string' &&
      this.valueControlStrChange
    ) {
      return 'pi pi-search';
    }
  }

  getBtnSeverity() {
    if (
      !this.hiddenRemoveValue &&
      ((typeof this.control.value === 'object' && this.control.value) ||
        (typeof this.control.value === 'string' &&
          this.control.value !== '' &&
          this.noResults))
    ) {
      return 'danger';
    } else if (
      this.filteredEntities.length !== 0 &&
      !this.valueControlStrChange
    ) {
      return 'primary';
    } else if (
      typeof this.control.value === 'string' &&
      this.valueControlStrChange
    ) {
      return 'primary';
    }
  }

  getBtnAction() {
    if (
      !this.hiddenRemoveValue &&
      ((typeof this.control.value === 'object' && this.control.value) ||
        (typeof this.control.value === 'string' &&
          this.control.value !== '' &&
          this.noResults))
    ) {
      return this.clearSelectValue();
    } else if (
      this.filteredEntities.length !== 0 &&
      !this.valueControlStrChange
    ) {
      return null;
    } else if (
      typeof this.control.value === 'string' &&
      this.valueControlStrChange
    ) {
      return this.onSearch();
    }
  }

  clearSelectValue() {
    this.notShowOptions = true;
    this.isLoading = false;
    this.stateSearch = false;
    this.noResults = false;
    this.isClear = true;
    this.filteredEntities = [];
    this.pageValue = 0;
    this.lastScrollTop = 0;
    this.keyEntities = 0;
    this.clearSelection.emit(true);
    this.onLoad(null);
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scroll, true);
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
